<template>
  <sc-link
    v-if="fields && fields.link"
    :field="fields.link"
    class="c-footer__link"
    :class="fields.link.value.class"
  />
</template>

<script>
import { Link } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Footer-UtilityLink',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {
    ScLink: Link
  }
};
</script>

<style lang="scss">
.c-footer {
  &__links {
    @include font-styles('Arial', 1.4rem, 400, normal, 2rem, 0, $white);

    .c-footer__link {
      display: block;
      color: $white;
      text-decoration: none;
      margin-bottom: 1rem;

      @include desktop-up {
        display: inline-block;
        padding: 0 1rem;
        margin-bottom: 0;
      }

      &:hover {
        text-decoration: underline;
      }

      &:after {
        @include desktop-up {
          content: '|';
          position: relative;
          right: -1rem;
        }
      }

      &:last-child {
        &:after {
          display: none;
        }
      }
    }
  }

  &__global {
    &.editMode {
      .c-footer__link {
        a {
          color: $white;
        }
      }
    }
  }
}
</style>
